import { Box } from "@mui/material";
import { useEffect } from "react";
import logout from "../../api/auth/logout";

export default function Logout() {
  useEffect(() => {
    logout(() => {
      console.log("Logged out");
      localStorage.clear();
      window.location = "/";
    });
  }, []);
  return (
    <Box>
      Logout
    </Box>
  );
}